/**
 * Note that all the keys in this file should follow the naming convention of `premialab:{ENTITY_NAME}`.
 */
export enum LocalStorageEntities {
  REGRESSION_METHODOLOGY = 'premialab:regression-methodology',

  RISK_PREFERENCES = 'premialab:constituent-risk-preferences-v2',
  POSITION_PREFERENCES = 'premialab:constituent-position-preferences-v6',

  UNIVERSE_OPTIONS = 'premialab:universe-options-v8',
  UNIVERSE_TABLE_COLUMN_REFERENCES = 'premialab:universe-table-column-preferences-v3',
  EQUITY_SCREENER_STOCKS_UNIVERSE_TABLE_COLUMN_PREFERENCES = 'premialab:equity-screener-stocks-universe-table-column-preferences-v3',
  EQUITY_SCREENER_BASKETS_UNIVERSE_TABLE_COLUMN_PREFERENCES = 'premialab:equity-screener-baskets-universe-table-column-preferences-v4',
  EQUITY_SCREENER_CHAT = 'premialab:equity-screener-chat',

  DSBColumns = `premialab:DSBColumns-v2`,
  LastUsedAnalyticsRoute = `premialab:LastUsedAnalyticsRoute-v3`,
  AnalysisPeriod = `premialab:AnalysisPeriod`,
  PORTFOLIO_VIEW_GROUPING_CONFIG = 'premialab:portfolio-view-grouping-config-v1',

  PERFORMANCE_CONTRIBUTION_LAYERED_TABLE_PREFERENCES = 'premialab:performance-contribution-layered-table-preferences',

  // No Code Dashboard
  NO_CODE_DASHBOARD_CHAT = 'premialab:noCodeDashboardChat',
  NO_CODE_DASHBOARD_LAST_USED_REPORT_ID = 'premialab:noCodeDashboardLastUsedReportId',

  RESOURCE_PAGE_CHAT = 'premialab:resourcePageChat',

  // Portfolio Construction
  METRIC_COLUMN_PREFERENCES = 'premialab:metricColumnPreferences',
  ANYWHERE_NAVIGATION_DSB_SEARCH_TEXT = 'premialab:anywhereNavigationDsbSearchText',
  AI_REPORT_PORTFOLIO_DSB_SEARCH_TEXT = 'premialab:aiReportPortfolioDsbSearchText',

  DSB_FAVORITE_FILTER = 'premialab:DsbFavoriteFilter',
  DSB_LIVE_FILTER = 'premialab:DsbLiveFilter',

  // Barra Composition
  BARRA_PREFERENCES = 'premialab:barraPreferences',

  // ADMIN
  SHOW_BETA_FEATURES = 'premialab:show-beta-features',
  ADMIN_CONSOLE_USE_LOCAL_TIMEZONE = 'premialab:admin-console-use-local-timezone',
  SHOULD_USE_ADMIN_BACK_DOOR = 'premialab:should-use-admin-back-door',
  USE_STRATEGY_MASK_UPDATED = 'premialab:use-strategy-mask-updated',
  SHOULD_USE_ALGO_QUANT = 'premialab:should-use-algo-quant',
  SHOULD_RESCALE_PORTFOLIO_WEIGHTS = 'premialab:should-rescale-portfolio-weights',
  SHOULD_USE_CLICKHOUSE = 'premialab:should-use-clickhouse',
  SHOULD_SHOW_A2A_NAVIGATION = 'premialab:should-show-a2a-navigation',

  SHOULD_USE_LAST_USED_ADMIN_ROUTE = 'premialab:should-use-last-used-admin-route',
  LAST_USED_ADMIN_ROUTE = 'premialab:last-used-admin-route',
}
